<template>
  <div>
    <img src="@/assets/images/bg1.jpg" class="bgImg" alt="">
    <div class="basic_wrap">

      <div class="login_bg">
        <!-- <div
        class="back_left"
        @click="$router.back()"
      /> -->
        <div class="big_tit">
          {{ $t('register.register') }}
        </div>
        <div class="language" style="right: 55px;width: 32px;height: 32px;" @click="toKefuLink">
            <img :src="require('../../assets/images/kefu.png')">
        </div>
        <div class="language" @click="$router.push('/language')">
            <img :src="require('../../assets/images/lang.png')">
        </div>
      </div>
      <div class="kefus">
        <img class="kefu_img" :src="logo">
      </div>
      <form class="form">
        <div class="cut_login">
          <router-link to="/login">
            {{ $t('register.signIn') }}
            <div class="line" />
          </router-link>
          <router-link class="cur" to="/register">
            {{ $t('register.signUp') }}
            <div class="line" />
          </router-link>
        </div>
        <div class="item">
          <span class="icon">
            <img src="../images/login/tel.png" alt="">
          </span>
          <a class="text-phone" @click.stop="countryShow = !countryShow">{{ data.country }}</a>
          <input v-model.trim="data.mobile" type="text" class="inp" :placeholder="$t('setpaypwd.pureNumber')">
          <div class="item_box" v-if="countryShow">
            <div class="search-box">
              <input type="text" v-model="searchCode" :placeholder="$t('搜索区号')" @input="inputFun"></input>
            </div>
            <a v-for="(item, index) in countrys" :key="index" :class="{ 'active': item.code === data.country }"
              @click.stop="onSelect(item)">
              {{ item.code }} {{ item.text }}
            </a>
          </div>
        </div>
        <div class="item">
          <span class="icon">
            <img src="../images/login/email.png" alt="">
          </span>
          <input v-model="data.email" type="text" class="inp" :placeholder="$t('请输入邮箱')">
        </div>
        <!-- <div class="item">
				<span class="icon">
					<img src="../images/login/p1.png" alt="">
				</span>
				<input type="text" class="inp" v-model.trim="data.name" placeholder="请输入用户名" />
			</div> -->
        <div class="item">
          <span class="icon">
            <img src="../images/login/lock.png" alt="">
          </span>
          <input v-model.trim="data.password" :type="password" class="inp" :placeholder="$t('register.password')">
          <div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
        </div>
        <!-- <div class="item">
        <span class="icon">
          <img
            src="../images/login/lock.png"
            alt=""
          >
        </span>
        <input
          v-model.trim="data.spassword"
          :type="password"
          class="inp"
          :placeholder="$t('register.passwordAgain')"
        >
        <div
          class="eye_bi"
          :class="password == 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div> -->

        <!-- 			<div class="item">
				<input type="password" class="inp" v-model.trim="data.paypwd" placeholder="请输入支付密码" />
			</div>
			<div class="item">
				<input type="password" class="inp" v-model.trim="data.confirm_paypwd" placeholder="请再次输入支付密码" />
			</div> -->

        <div v-if="show_sms > 0" class="item">
          <input v-model.trim="data.code" type="text" class="inp" :placeholder="$t('register.code')">
          <van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
            <template v-slot="timeData">
              <span @click="sendcode">{{
                timeData.seconds > 0
                  ? timeData.seconds
                  : $t('register.sendCode')
                }}</span>
            </template>
          </van-count-down>
        </div>
        <div class="item">
          <span class="icon">
            <img src="../images/login/p2.png" class="people" alt="">
          </span>
          <input v-model.trim="data.invite_code" type="text" class="inp" :placeholder="$t('invite_code')">
        </div>
      </form>
      <div class="basic_btn sbtn" :class="data.mobile == '' ||
          data.password == ''
          //||data.code == ''
          ? 'no_touch'
          : ''
        " @click="submit">
        {{ $t('register.signUpBtn') }}
      </div>
      <van-dialog v-model="statement" confirm-button-color="#fb661e" :close-on-click-overlay="true"
        @click="privacyStatementHide">
      </van-dialog>
      <van-dialog v-model="agreement" confirm-button-color="#fb661e" :close-on-click-overlay="true"
        @click="agreementHider">
      </van-dialog>

      <!-- <div
      v-if="msg_show"
      class="kefu"
      :class="show_kefu ? '' : 'kefu_hide'"
      @click="kefu_to"
    >
      <img class="kefu_img" src="@/assets/images/logo2.png">
    </div> -->
    </div>
  </div>

</template>

<script>
import Vue from "vue";
import { CountDown, Checkbox, Dialog } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(CountDown)
  .use(Checkbox)
  .use(Dialog);

export default {
  name: "Register",
  data() {
    return {
      countryShow: false,
      countrys: [],
      countrys2:[],
      logo: localStorage.getItem('logo') || '',
      time: 0,
      agreement: false,
      statement: false,
      show_kefu: false,
      msg_show: true,
      show_sms: 0,
      kefu_link:'',
      password: "password",
      data: {
        password: "",
        spassword: "",
        email: "",
        mobile: "",
        code: "",
        invite_code: "",
        agent: 10000,
        country: localStorage.getItem('countryCode') || "+93"
      },
      config: {},
      searchCode:''
    };
  },
  created() {
    this.$parent.footer("user", false);
    Fetch("/index/webconfig").then((r) => {
        this.kefu_link = r.data.kefu_link
    });
    Fetch("/loan/countrys").then((r) => {
      this.countrys = r.data.map(x => {
        return { text: x.name, code: x.code }
      })
      this.countrys2 = r.data.map(x => {
        return { text: x.name, code: x.code }
      })
    });
    // this.getparams();
    // 安卓返回IMEI，苹果返回UID值
    /*BSL.PhoneID('callName');
  window.callName = this.methodName;
  // 获取手机OAID
  BSL.GetOAID('getExternalInfo');
  window.getExternalInfo = this.getExternalInfoData; */
  },
  mounted() {
    if (this.$route.query.invite_code) {
      this.data.invite_code = this.$route.query.invite_code;
    }
    if (this.$route.query.agent) {
      localStorage.setItem('agent', this.$route.query.agent);
      this.data.agent = this.$route.query.agent;
    } else {
      if (localStorage.getItem('agent')) {
        this.data.agent = localStorage.getItem('agent');
      }
    }
    var that = this;
    document.body.addEventListener(
      "scroll",
      function () {
        if (!that.show_kefu) {
          return;
        }
        that.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      function (ev) {
        if (ev.target.className != "kefu_img") {
          that.show_kefu = false;
        }
      },
      false
    );
    Fetch('/index/webconfig', { type: 'web' }).then(res => {
      this.config = res.data
      this.show_sms = res.data.sms_verify
    })
  },
  methods: {
    inputFun() {
            // 如果输入框为空，恢复原始数据
            if (!this.searchCode) {
                this.countrys = [...this.countrys2];
                return;
            }

            // 筛选逻辑：精准匹配区号数字
            const searchValue = this.searchCode;
            this.countrys = this.countrys2.filter(item => {
                // 去除code中的+号，只保留数字进行匹配
                const codeNumber = item.code.replace('+', '');
                // 精准完全相等匹配
                return codeNumber === searchValue;
            });
        },
    toKefuLink() {
        window.location.href = this.kefu_link
    },
    onSelect(action) {
      this.data.country = action.code
      this.countryShow = false
    },
    kefu_to() {
      if (this.show_kefu) {
        this.$router.push("/kefu");
      }
      this.show_kefu = !this.show_kefu;
    },
    showPwd() {
      if (this.password == "password") {
        this.password = "text";
      } else {
        this.password = "password";
      }
    },
    methodName(r) {
      this.data.imei = r;
    },
    getExternalInfoData(info) {
      var info = JSON.parse(info);
      console.log(info);
      if (info.code == 0) {
        this.data.oaid = info.oaid;
      }
    },
    getparams() {
      var m = this.$route.query.m;
      this.data.invite_code = m;
    },
    timeCall() {
      this.is_send = false;
      this.time = 0;
    },
    sendcode() {
      if (this.is_send) {
        return;
      }

      if (!this.data.mobile) {
        this.$toast(this.$t('register.phoneEmpty'));
        return;
      }

      this.is_send = true;

      Fetch("/index/register_code", {
        mobile: this.data.mobile,
      })
        .then(() => {
          this.time = 60 * 1000;
          this.$toast({
            background: "#07c160",
            message: this.$t('register.sendSuccess'),
          });
        })
        .catch(() => {
          this.is_send = false;
        });
    },
    submit() {
      if (!this.data.mobile) {
        this.$toast(this.$t('setpaypwd.pureNumber'));
        return false;
      }
      if (!this.data.password) {
        this.$toast(this.$t('register.passwordEmpty'));
        return false;
      }
      // if (!this.data.spassword) {
      //     this.$toast(this.$t('register.passwordAgainEmpty'));
      //     return false;
      // }
      if (!this.data.invite_code) {
        this.$toast(this.$t('invite_code'));
        return false;
      }

      if (!this.data.code && this.config.sms_verify) {
        this.$toast(this.$t('register.codeEmpty'));
        return false;
      }
      // if (this.data.password != this.data.spassword) {
      //     this.$toast(this.$t('register.passwordError'));
      //     return false;
      // }

      Fetch("/index/register", {
        ...this.data,
      }).then((res) => {
        if (res.code == 1) {
          if (res.data.token) {
            localStorage.setItem('token', res.data.token);
          }
          this.$toast(this.$t('register.signUpSuccess'));
          setTimeout(() => {
            this.$router.replace("/");
          }, 1000)
          return
        }
        this.$toast(res.msg);
      });
    },
    userAgreement() {
      this.agreement = true;
    },
    agreementHider() {
      this.agreement = false;
    },
    privacyStatement() {
      this.statement = true;
    },
    privacyStatementHide() {
      this.statement = false;
    },
  },
};
</script>

<style lang="less" scoped>
.login_bg {
  width: 100%;
  height: 40px;
  background-size: 100% 100%;
  overflow: hidden;
  .language {
        position: absolute;
        top: 8px;
        right: 10px;
        height: 30px;

        img {
            height: 100%;
        }
    }
}

.basic_wrap {
  width: 100%;
  height: 100%;
  max-width: 750px;
  min-height: 100dvh;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  background: rgba(0, 0, 0, 0.7);
  // background: url('~@/assets/images/bg1.jpg') no-repeat center center / cover;
}

.basic_wrap .form {
  margin: 5em auto;
  width: 90%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
  border-radius: 13px;
  padding: 31px 24px 31px 24px;
}

.cut_login {
  width: 207px;
  line-height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  text-align: center;
  margin: 0 auto;

  a {
    width: 50%;
    padding-bottom: 10px;
    color: #999;
    position: relative;

    .line {
      width: 100%;
      height: 1px;
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: #f2f2f2;
    }
  }

  a.cur {
    color: #000;

    .line {
      height: 2px;
      background-image: linear-gradient(to right, #000, #000);
    }
  }
}

.block {
  width: 100%;
  height: 100%;
  // overflow:hidden;
  // margin: 10% auto;
  font-size: 15px;
  justify-content: center;
  background-color: #fff;
  border-radius: 5px;

  .block-title {
    display: block;
    font-weight: bolder;
    line-height: 39px;
    height: 39px;
    text-align: center;
  }

  .p_agr {
    // padding-top:30rpx;
    font-size: 12px;
    /*font-weight: bolder;*/
    line-height: 20px;
    padding: 0px 10px;
    height: 388px;
    /*overflow: hidden;*/
    // overflow: auto;
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
  }

  .div_qd {
    width: 60px;
    height: 25px;

    span {
      width: 60px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      justify-content: center;
      background: #fb661e;
      border-radius: 10px;
      padding: 1px 5px;
      color: #fff;
    }

    margin: 10px auto;
  }
}

.item {
  height: 58px;
  border-bottom: 1px solid #f0f1f3;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 4px;
  position: relative;

  .item_box {
    width: 100%;
    height: 320px;
    overflow-y: scroll;
    position: absolute;
    left: 0px;
    top:50px;
    background: #fff;
    box-shadow: 0 0 3px #999;
    border-radius: 10px;
    padding: 10px 10px 0px 10px;
    z-index: 10;

    .search-box {
      height: 40px;
      width: 100%;
      background: #eee;
      border-radius: 8px;
      margin-bottom: 10px;
      padding: 0 10px;
      box-sizing: border-box;

      input {
        width: 100%;
        height: 100%;
        font-size: 14px;
      }
    }
    a {
      display: block;
      width: 100%;
      height: 38px;
      border-bottom: 1px solid #eee;
      line-height: 38px;
      padding: 0 8px;
    }

    .active {
      background: #eee;
    }
  }

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 28px;
    height: 24px;

    .people {
      width: 23px;
      height: 20px;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  input {
    height: 20px;
    margin-left: 7px;
    flex: 1;
    margin-bottom: 3px;
  }
}

.get_captcha {
  width: 88px;
  height: 34px;
  background: linear-gradient(90deg,
      rgba(228, 57, 46, 1) 0%,
      rgba(254, 76, 22, 1) 100%);
  border-radius: 4px;
  text-align: center;
  line-height: 34px;
  font-size: 14px;
  color: #ffffff;
}

.protocol {
  font-size: 12px;
  line-height: 17px;
  margin-top: 20px;
  color: #999999;

  a {
    color: #3d96ff;
  }
}

.basic_btn {
  margin: 36px auto 0 auto;
  box-shadow: 0 0 5px #eee;
}

.text-phone {
  display: flex;
  align-items: flex-end;
  cursor: pointer;
  padding-right: 20px;
  padding-bottom: 0px;
  line-height: 28px;
  background-image: url(~@/assets/images/xjt.png);
  background-repeat: no-repeat;
  background-size: 12px 12px;
  background-position: right 34px;
}
.big_tit {
  color: #fff !important;
}
</style>
